import type { NodeReferences } from "../schemas/shared/refsSchema.ts";
import { extractNodeValueRefIds } from "./extractNodeValueRefIds.ts";
import { extractRefIds } from "./extractRefIds.ts";

interface BuildableConfig {
  refs?: NodeReferences;
}

/**
 * Every node id a condition or effect config names, by either route it has: the
 * `refs` its buildable declared, and the node-value references configured
 * anywhere within it.
 */
export const configReferencedNodeIds = (config: BuildableConfig): number[] => [
  ...extractRefIds(config.refs),
  ...extractNodeValueRefIds(config),
];

/**
 * The same question asked of a whole `byId`, walking each config once however
 * many nodes are then searched for. The walk is deep and the searches come in
 * batches: `resolveNodeLinkagesPreventingMoveToSlot` asks for every node that
 * would leave scope, while a drag is in progress.
 */
export const configReferencesNodeIdCreate = (byId: Record<string, { config: BuildableConfig }>) => {
  const referencedNodeIdsByConfigId = new Map(
    Object.entries(byId).map(([configId, { config }]) => [configId, new Set(configReferencedNodeIds(config))] as const),
  );

  return (configId: string, nodeId: number): boolean => !!referencedNodeIdsByConfigId.get(configId)?.has(nodeId);
};
